DialogController = App.loadClass 'core::Angular/DialogController'

class exports.ChemicalsChildrenController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @chemicalsService, @chemical, @chemicals) ->
        super
        @scope.title = "#{@chemical.name}: Add Children"
        @scope.chemical = @chemical
        @scope.list1 = []
        @scope.list2 = @chemical.children or []
        @scope.selected = { category: @chemical.category }
        @scope.categories = [
            'Fungicide',
            'Herbicide',
            'Insecticide',
            'Growth Regulator',
            'Fumigant',
            'Defoliant'
        ]

        @scope.moveRight = (items) =>
            for item in items
                idx = -1
                for chemical, i in @scope.list1
                    if chemical.id is item.id
                        idx = i
                @scope.list1.splice idx, 1
                @scope.list2.push item

        @scope.moveLeft = (items) =>
            for item in items
                idx = -1
                for chemical, i in @scope.list2
                    if chemical.id is item.id
                        idx = i
                @scope.list2.splice idx, 1
                @scope.list1.push item

        @scope.loadAvailableChemicals = (category) =>
            # Load left list
            @scope.list1 = @chemicals
            # Filter by category
            .filter (chemical) -> chemical.category is category
            # Filter out items that are already your children
            .filter (chemical) => not @scope.list2.filter((item) -> item.id is chemical.id).length
            # Filter out items that have children
            .filter (chemical) => not chemical.children?.length
            # Filter out self
            .filter (chemical) => chemical.id isnt @chemical.id

            # Filter right list
            @scope.list2 = @scope.list2.filter (chemical) -> chemical.category is category

        if @scope.selected.category
            @scope.loadAvailableChemicals @scope.selected.category

    save: () =>
        @chemical.category = @scope.selected.category
        @chemical.children = @scope.list2
        if @chemical.children.length is 0
            @chemical.max_wind_speed = null
            @chemical.mode_of_action = null
        @chemicalsService.saveChemical @chemical
        .then (response) =>
            @closeWithAlert
                type: 'success'
                msg: 'Successfully saved children'
            , response.data
        .catch (response) =>
            @setAlert
                type: 'error'
                msg: 'An error has occurred'
